<template>
   <div class="__container-landing flex min-h-screen flex-col items-center gap-10 pt-20">
      <SlideUp>
         <TitleDescription
            center
            description-center
            max-w
            heading="h1"
            title-class="h-xxl"
            :title="$t('web.pages.index.faq.title')"
            :description="$t('web.pages.index.faq.description')"
         />
      </SlideUp>

      <FadeIn class="rounded-medium bg-white p-5 pb-0 pt-9 md:px-10">
         <template v-for="(_, index) in Array(31)">
            <Accordion
               :title="t(`web.faq.${index + 1}-q`)"
               :content="t(`web.faq.${index + 1}-a`)"
            />
         </template>
         <Accordion :title="t('web.pages.index.faq.cta-title')">
            <NuxtLink :to="$localePath('/contact-us')">
               <Button variant="secondary" large>
                  {{ t('web.pages.index.faq.cta') }}
               </Button>
            </NuxtLink>
         </Accordion>
      </FadeIn>
   </div>
</template>

<script lang="ts" setup>
const { t } = useI18n()

useSeo(t('web.seo.index.faq.title'), t('web.seo.index.faq.description'))

const faq = computed(() =>
   Array.from({ length: 31 }, (_, i) => ({
      question: t(`web.faq.${i + 1}-q`),
      answer: t(`web.faq.${i + 1}-a`),
   }))
)

useSchemaOrg([
   defineWebPage({
      '@type': 'FAQPage',
   }),
   ...faq.value.map((item) =>
      defineQuestion({
         name: item.question,
         acceptedAnswer: item.answer,
      })
   ),
])
</script>
